import { SUPPORTED_NON_DEFAULT_LOCALE_PREFIXES } from 'Pods/Shared/Utils/getLocaleParam'

const DEFAULT_LISTING_PATH = '3d-models'
const FALLBACK_LOCALE_PREFIXES = SUPPORTED_NON_DEFAULT_LOCALE_PREFIXES

function getListingBasePath() {
  if (typeof window === 'undefined') {
    return DEFAULT_LISTING_PATH
  }

  const pathSegments = window.location.pathname.split('/').filter(Boolean)

  if (!pathSegments.length) {
    return DEFAULT_LISTING_PATH
  }

  const currentLocale = window.I18n?.locale?.toLowerCase()
  const defaultLocale = window.I18n?.defaultLocale?.toLowerCase()
  const firstSegment = pathSegments[0].toLowerCase()
  const hasExplicitLocale = currentLocale
    && defaultLocale
    && currentLocale !== defaultLocale
    && firstSegment === currentLocale

  if (hasExplicitLocale && pathSegments[1]) {
    return pathSegments[1]
  }

  if (FALLBACK_LOCALE_PREFIXES.includes(firstSegment) && pathSegments[1]) {
    return pathSegments[1]
  }

  if (FALLBACK_LOCALE_PREFIXES.includes(firstSegment)) {
    return DEFAULT_LISTING_PATH
  }

  return pathSegments[0] || DEFAULT_LISTING_PATH
}

export default getListingBasePath
